<template>
  <b-card-text>
      <b-row class="detail-employee">
        <b-col cols="12" lg="3" class="text-center mypage__sidebar">
          <Sidebar />
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">所在地</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor" v-if="detailCompany.zip_code">{{"〒"+detailCompany.zip_code.slice(0, 3)+"-"+detailCompany.zip_code.slice(3, 7)+(detailCompany.address? detailCompany.address: '')}}</div>
              <div class="vendor-content-infor" v-if="!detailCompany.zip_code">{{detailCompany.address}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">事業内容</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor vendor-content-infor-long">{{detailCompany.business_content}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">従業員数</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{formatNumber(detailCompany.number_employees)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">資本金</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{formatNumber(detailCompany.capital)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">代表者名</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{detailCompany.representative_name}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">代表電話番号</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{detailCompany.representative_phone}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">メールアドレス</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{detailCompany.representative_email}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row border-0 align-items-baseline">
            <b-col cols="4" lg="3" class="pl-0">
              <div class="vendor-title">ホームページ</div>
            </b-col>
            <b-col cols="8" lg="9">
              <div class="vendor-content-infor">{{detailCompany.homepage}}</div>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center mb-30">
            <button class="btn btn-vendorEdit btn-rounder btn-edit" @click.prevent="editVendor">
              <i class="icon-i-edit"></i>
              <span>編集</span>
            </button>
          </div>
        </b-col>
      </b-row>
  </b-card-text>
</template>

<script>
import Sidebar from '@/views/Admin/Company/Sidebar'
import {mapState} from 'vuex'
export default {
  name: 'admin_detail_vendor_information',
  components: {
    Sidebar
  },
  data () {
    return {

    }
  },
  methods: {
    editVendor () {
      const id = this.$route.params.id
      this.$router.push(`/admin/companies/edit/${id}`)
    }
  },
  computed: {
    ...mapState({
      detailCompany: state => state.adminCompany.detailCompany
    })
  },
  mounted () {
    this.$store.dispatch('adminCompany/detailCompany', this.$route.params.id)
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/stylesheet/admin/vendor.scss";
@import '@/assets/stylesheet/vendor/detail_vendor.scss';
@import '@/assets/stylesheet/user/detail_user.scss';
</style>



// WEBPACK FOOTER //
// src/components/Admin/Company/Information.vue